import styled from 'styled-components';
import React from 'react';

const PowerButtonStyled = styled.i`
  cursor: ${({ isPaused }) => (isPaused ? 'default' : 'pointer')};
  transition: color 0.3s;
  &:hover {
    color: ${({ isPaused }) => (isPaused ? 'initial' : '#cc0000')};
  }
`;

export const PowerButton = ({ isPaused, onClick }) => {
  return (
    <PowerButtonStyled
      isPaused={isPaused}
      className="ni ni-button-power"
      onClick={onClick}
    />
  );
};
